// On a phone the panel is a sheet at the foot of the map: a peek with the
// search box and a strip of cards, half open, or full. Dragged by the handle
// or by touching the head; never by the list, which scrolls.

const SNAPS = ['peek', 'half', 'full'];

export function createSheet(ctx) {
  const panel = document.getElementById('atlasPanel');
  const handle = panel.querySelector('.atlas-sheet-handle');
  const mq = window.matchMedia('(max-width: 767px)');
  let snap = 'peek';
  let drag = null;

  function isMobile() { return mq.matches; }
  function setSnap(s) {
    snap = s;
    panel.dataset.snap = s;
    panel.style.transform = '';
    document.body.classList.toggle('atlas-sheet-open', s !== 'peek');
    ctx.onSnap(s);
  }
  function start(e) {
    if (!isMobile()) return;
    const t = e.touches ? e.touches[0] : e;
    drag = { y: t.clientY, top: panel.getBoundingClientRect().top, moved: false };
    panel.classList.add('is-dragging');
  }
  function move(e) {
    if (!drag) return;
    const t = e.touches ? e.touches[0] : e;
    const dy = t.clientY - drag.y;
    if (Math.abs(dy) > 4) drag.moved = true;
    panel.style.transform = `translateY(${Math.max(-drag.top + 40, dy)}px)`;
    if (drag.moved && e.cancelable) e.preventDefault();
  }
  function end(e) {
    if (!drag) return;
    panel.classList.remove('is-dragging');
    const t = e.changedTouches ? e.changedTouches[0] : e;
    const dy = t.clientY - drag.y;
    const i = SNAPS.indexOf(snap);
    if (!drag.moved) { setSnap(snap === 'peek' ? 'half' : snap === 'half' ? 'full' : 'peek'); }
    else if (dy < -60) setSnap(SNAPS[Math.min(2, i + 1)]);
    else if (dy > 60) setSnap(SNAPS[Math.max(0, i - 1)]);
    else setSnap(snap);
    drag = null;
  }
  for (const el of [handle, panel.querySelector('.atlas-panel-head')]) {
    if (!el) continue;
    el.addEventListener('touchstart', start, { passive: true });
    el.addEventListener('touchmove', move, { passive: false });
    el.addEventListener('touchend', end);
  }
  handle.addEventListener('click', () => { if (!drag) setSnap(snap === 'peek' ? 'half' : snap === 'half' ? 'full' : 'peek'); });
  mq.addEventListener('change', () => setSnap(isMobile() ? 'peek' : 'full'));
  setSnap(isMobile() ? 'peek' : 'full');

  // The horizontal strip: when peeking, scrolling the strip selects nothing;
  // a tap on a card does. The strip is the same list element laid out as a row.
  return { isMobile, setSnap, snap: () => snap, open: () => setSnap('half'), peek: () => setSnap('peek') };
}
